import 'angular:locale/data:it';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "it";
